import { registerDe } from '../i18n/index.js';

registerDe({
  // 'queued', 'stub', 'operator', 'clean' are translated by SignalsPage / InboxPage / PersonPage / ReviewPage
  // (one catalogue per key); 'failed' and 'no worker' are context variants (tCtx) — 'failed‖run' agrees
  // with a run, 'no worker‖scout' names a process.
  // 'Agents', 'System' (nav) live in registry.de.ts / common; 'not collected', 'Loading…',
  // 'person', 'organisation', the refuse reasons and 'other' live in common.de.ts.
  'one tool registry, two transports': 'ein Werkzeugregister, zwei Transportwege',
  'every caller is a principal with scopes': 'jeder Aufrufer ist ein Prinzipal mit Berechtigungen',
  'the scout never touches the database': 'der Scout rührt die Datenbank nie an',
  'Event feed →': 'Ereignisstrom →',
  'New principal': 'Neuer Prinzipal',
  'Checking…': 'Wird geprüft…',
  'checking…': 'wird geprüft…',
  'Ready': 'Bereit',
  'Attend': 'Aufmerksamkeit',
  'LiteLLM': 'LiteLLM',
  'model unset': 'Modell nicht gesetzt',
  'unreachable': 'nicht erreichbar',
  'Harness': 'Harness',
  'found': 'gefunden',
  'not found': 'nicht gefunden',
  'runtime': 'Laufzeit',
  'cap {n}': 'Grenze {n}',
  'night': 'Nacht',
  'embedding': 'Embedding',
  'reranker': 'Reranker',
  'scout': 'Scout',
  'seen {time}': 'gesehen {time}',
  'last seen {time}': 'zuletzt gesehen {time}',
  'no worker\u2016scout': 'kein Worker',
  'mail': 'Mail',
  'inbound': 'eingehend',
  'Surfe': 'Surfe',
  'search': 'Suche',
  'email': 'E-Mail',
  'Hermes': 'Hermes',
  'not installed': 'nicht installiert',
  'installed': 'installiert',
  'config has crm': 'Konfiguration enthält crm',
  'config lacks crm': 'Konfiguration ohne crm',
  'last call': 'letzter Aufruf',
  'Database': 'Datenbank',
  'Re-check': 'Erneut prüfen',
  'Runs · 24h': 'Läufe · 24 Std.',
  'no run in the last 24 hours': 'kein Lauf in den letzten 24 Stunden',
  '{done} done · {failed} failed · {active} active': '{done} fertig · {failed} fehlgeschlagen · {active} aktiv',
  'the ledger did not answer': 'das Protokoll hat nicht geantwortet',
  'counting…': 'wird gezählt…',
  'Filed': 'Eingereicht',
  'no proposal has come from an agent yet': 'noch kein Vorschlag von einem Agenten',
  '{unheld} unheld · {held} held · {refused} refused': '{unheld} offen · {held} übernommen · {refused} abgelehnt',
  'proposals by agents, all time': 'Vorschläge von Agenten, gesamt',
  'Pushed back': 'Zurückgewiesen',
  '{n} on {principal} · {reason}': '{n} bei {principal} · {reason}',
  'no agent proposal refused in 7 days': 'kein Agentenvorschlag in 7 Tagen abgelehnt',
  'refused proposals by agents, 7 days': 'abgelehnte Vorschläge von Agenten, 7 Tage',
  'Hermes · 24h': 'Hermes · 24 Std.',
  'calls': 'Aufrufe',
  'Hermes is not installed on this host': 'Hermes ist auf diesem Host nicht installiert',
  'no call from hermes in 24 hours': 'kein Aufruf von hermes in 24 Stunden',
  '{read} read · {propose} propose · 0 commit · 0 send': '{read} lesen · {propose} vorschlagen · 0 festschreiben · 0 senden',
  'ledger calls by principal hermes': 'Protokollaufrufe des Prinzipals hermes',
  'Send scope': 'Sendeberechtigung',
  'off': 'aus',
  'for every agent': 'für jeden Agenten',
  'only the operator sends': 'nur der Operator versendet',
  'Runs': 'Läufe',
  'one run = one sentence and its seal': 'ein Lauf = ein Satz und sein Siegel',
  'Could not load the runs: {error}': 'Die Läufe konnten nicht geladen werden: {error}',
  'The runner has not reported yet. A run is one DeepSeek Harness process per skill — research, mail triage, transcript, persona — with its own principal, its own token and its own ledger rows.':
    'Der Läufer hat noch nichts gemeldet. Ein Lauf ist ein DeepSeek-Harness-Prozess pro Fähigkeit — Recherche, Mail-Triage, Transkript, Persona — mit eigenem Prinzipal, eigenem Token und eigenen Protokollzeilen.',
  'No run yet. "Research" on a person or an organisation starts one; the nightly schedule starts the rest.':
    'Noch kein Lauf. «Recherchieren» bei einer Person oder Organisation startet einen; der nächtliche Zeitplan startet die übrigen.',
  'failed\u2016run': 'fehlgeschlagen',
  'aborted': 'abgebrochen',
  'running': 'läuft',
  'schedule': 'Zeitplan',
  'event': 'Ereignis',
  'agent': 'Agent',
  'filed': 'eingereicht',
  'turns': 'Züge',
  'tokens': 'Tokens',
  'Abort': 'Abbrechen',
  'Open this run’s desk': 'Den Arbeitsplatz dieses Laufs öffnen',
  '{ref} aborted.': '{ref} abgebrochen.',
  'Event feed': 'Ereignisstrom',
  'append-only · what the consumers and Hermes read': 'nur anhängend · was die Konsumenten und Hermes lesen',
  'Could not load the events: {error}': 'Die Ereignisse konnten nicht geladen werden: {error}',
  'No event yet. The first interaction, commitment, proposal or signal writes one.': 'Noch kein Ereignis. Die erste Interaktion, Zusage, der erste Vorschlag oder das erste Signal schreibt eines.',
  'Tool registry': 'Werkzeugregister',
  'capabilities by scope · which principals hold them': 'Fähigkeiten nach Scope · welche Principals sie halten',
  'tools': 'Werkzeuge',
  'Could not load the registry: {error}': 'Das Register konnte nicht geladen werden: {error}',
  'no principal holds it': 'kein Prinzipal hält sie',
  'not a capability': 'keine Fähigkeit',
  'operator only': 'nur der Operator',
  'Defined once (P9); served as REST, as MCP over HTTP for Hermes and for every run’s harness, and over stdio for Claude Code. Scope is checked in the tool layer, never in a prompt. Every call writes one ledger row, refusals included.':
    'Einmal definiert (P9); als REST, als MCP über HTTP für Hermes und für den Harness jedes Laufs und über stdio für Claude Code bereitgestellt. Berechtigungen werden in der Werkzeugschicht geprüft, nie im Prompt. Jeder Aufruf schreibt eine Protokollzeile, Ablehnungen eingeschlossen.',
}, 'AgentsPage');
